import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';




const json = {
  1: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P39-E1',
    audio: 'img/FriendsPlus/Page39/Audio/audio-e1-p39.mp3',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page39/Audio/tieude-e1-p39.mp3' },
        { url: 'img/FriendsPlus/Page39/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page39/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/7.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page39/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page39/Audio/boy.mp3' },
        { url: 'img/FriendsPlus/Page39/E1/9.jpg', audioUrl: 'img/FriendsPlus/Page39/Audio/toy.mp3' },
        { url: 'img/FriendsPlus/Page39/E1/10.jpg', audioUrl: 'img/FriendsPlus/Page39/Audio/oyster.mp3' },
        { url: 'img/FriendsPlus/Page39/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page39/E1/12.jpg', audioUrl: 'img/FriendsPlus/Page39/Audio/coin.mp3' },
        { url: 'img/FriendsPlus/Page39/E1/13.jpg', audioUrl: 'img/FriendsPlus/Page39/Audio/oil.mp3' },
        { url: 'img/FriendsPlus/Page39/E1/14.jpg', audioUrl: 'img/FriendsPlus/Page39/Audio/soil.mp3' },
      ],

    ],
  },
  2: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P39-E2',
    audio: 'img/FriendsPlus/Page39/Audio/audio-e2-p39.mp3',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page39/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page39/Audio/tieude-e2-p39.mp3' },
        { url: 'img/FriendsPlus/Page39/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page39/E2/4.jpg' },

      ],

    ],
  },
  3: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P39-E3',
    audio: '',
    video: '',
    totalInput: 12,
    component: DesignUnderLine,
    exerciseKey: 'img/FriendsPlus/Page39/E3/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E3/0.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page39/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page39/E3/4.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page39/E3/5.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/6.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page39/E3/7.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/8.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page39/E3/9.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/10.jpg', input: 6, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/11.jpg', input: 7, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/12.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page39/E3/13.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page39/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/15.jpg', input: 8 },
        { url: 'img/FriendsPlus/Page39/E3/16.jpg', input: 9 },
        { url: 'img/FriendsPlus/Page39/E3/17.jpg', input: 10 },
        { url: 'img/FriendsPlus/Page39/E3/18.jpg', input: 11, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/19.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page39/E3/20.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/21.jpg', input: 12 },
        { url: 'img/FriendsPlus/Page39/E3/22.jpg', input: 13, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/23.jpg', input: 14, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/24.jpg', input: 15, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/25.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page39/E3/26.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page39/E3/27.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/28.jpg', input: 16 },
        { url: 'img/FriendsPlus/Page39/E3/29.jpg', input: 17 },
        { url: 'img/FriendsPlus/Page39/E3/30.jpg', input: 18 },
        { url: 'img/FriendsPlus/Page39/E3/31.jpg', input: 19 },
        { url: 'img/FriendsPlus/Page39/E3/32.jpg', input: 20, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/33.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page39/E3/34.jpg' },
        { url: 'img/FriendsPlus/Page39/E3/35.jpg', input: 21 },
        { url: 'img/FriendsPlus/Page39/E3/36.jpg', input: 22, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/37.jpg', input: 23, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/38.jpg', input: 24, isCorrect: true },
        { url: 'img/FriendsPlus/Page39/E3/39.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page39/E3/40.jpg' },
      ],


    ],
  },
  4: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P39-E4',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page39/E4/Key/answerKey.png',
    component: D1,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page39/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page39/E4/3.jpg', input: true, answer: "boy" },
        { url: 'img/FriendsPlus/Page39/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page39/E4/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page39/E4/6.jpg' },
        { url: 'img/FriendsPlus/Page39/E4/7.jpg', input: true, answer: "oyster" },
        { url: 'img/FriendsPlus/Page39/E4/8.jpg' },
        { url: 'img/FriendsPlus/Page39/E4/9.jpg', input: true, answer: "coin" },
        { url: 'img/FriendsPlus/Page39/E4/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page39/E4/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page39/E4/12.jpg' },
        { url: 'img/FriendsPlus/Page39/E4/13.jpg', input: true, answer: "oil" },
        { url: 'img/FriendsPlus/Page39/E4/14.jpg' },
        { url: 'img/FriendsPlus/Page39/E4/15.jpg', input: true, answer: "toy" },
        { url: 'img/FriendsPlus/Page39/E4/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page39/E4/17.jpg' },
      ],


    ],
  },
  5: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P39-E5',
    audio: '',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page39/E5/1.jpg' },
      ]
    ],
  },



}

export default json;
